export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.5 3a1 1 0 01.919.606l1.24 2.894H21v2h-1.148l-1.865 11.658A1 1 0 0117 21H7a1 1 0 01-.987-.842L4.147 8.5H3v-2h1.34l1.241-2.894.068-.131A1 1 0 016.5 3h11zM7.853 19h8.295l1.68-10.5H6.172L7.853 19zM6.517 6.5h10.966L16.841 5H7.159l-.642 1.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};